module.exports = __webpack_public_path__ + "static/img/logo-bg.19250b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/logo-bg.jpg
// module id = 12wW
// module chunks = 1